import React, { useState, useMemo } from "react";
import styled from "styled-components";
import { updateIsActive } from "../../../admin";
import { usePrivacy } from "../../../contexts/PrivacyContext";
import { hasCourseEnded } from "../../../utils/courseSchedule";


const GroupHeader = ({ course, groupsCount, hasGroups }) => {
    const { maskCourseName } = usePrivacy();
    const [isActive, setIsActive] = useState(course.isActive ?? false);

    const canDeactivate = useMemo(() => {
        if (!course?.endDate) return true; // no end date -> can deactivate
        return hasCourseEnded(course);
    }, [course]);

    // null or end time still ahead
    const canActivate = useMemo(() => !hasCourseEnded(course), [course]);


    const handleActiveClick = () => {
        if (!hasGroups || groupsCount < 1) {
            alert('Add at least one group to activate.');
            updateIsActive(course.id, isActive);
            setIsActive(isActive);
            return;
        }
        const next = !isActive;
        if (isActive && !next && !canDeactivate) {
            alert('You can only deactivate when the end date is empty or earlier than today.');
            return;
        }

        if (!isActive && next && !canActivate) {
            alert('Set an end date to today or later (or clear it) to activate.');
            return;
        }
        updateIsActive(course.id, next);
        setIsActive(next);
        // Dispatch custom event to notify home page to refresh
        window.dispatchEvent(new CustomEvent('courseActiveStatusChanged', { 
            detail: { courseId: course.id, isActive: next } 
        }));
        // Store timestamp in sessionStorage to indicate course status changed
        sessionStorage.setItem('courseStatusChanged', Date.now().toString());
        //console.log("Change the course ", course.name, "to active state: ", next);
    };

    return (
        <GroupInfo>
            <Title>{maskCourseName(course.name, course.id)}</Title>
            <SortButtonWrapper>
                <SortButton
                    onClick={handleActiveClick}
                    title={
                        isActive && !canDeactivate
                            ? 'Set an end date in the past (or clear it) to deactivate'
                            : ''
                    }
                > {isActive ? "Deactivate Course" : "Activate Course"} </SortButton>
            </SortButtonWrapper>
        </GroupInfo>
    );
};




const Title = styled.div`
    font-size: 24px;
    font-weight: 600;
    color: #333;
    width: 50%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: left;
    margin-left: 10px;
`;

const GroupInfo = styled.div`
    background-color: #f8fafc;
    border-radius: 10px;
    padding: 20px;
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const SortButtonWrapper = styled.div`
    margin-right: 0.4%;
    position: relative;
`;

const SortButton = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 9999px;
    padding: 5px 10px;
    margin-right: 10px;
    font-weight: 600;
    cursor: pointer;
    font-size: 16px;
    color: #4b5563;
    background: #e5e7eb;
    width: 180px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &:hover {
        background-color: #ef4444;
        color: #fff;
    }

    &:focus {
        box-shadow: 0 0 0 2px #dc2626;
        color: #fff;
    }
`;

export default GroupHeader;

